<div class="heroBanner bgPrimary">
    <div class="container">
        <h1 class="colorWhite text-center">Ways To Give Online</h1>
    </div>
    
</div>

<div class="bgWhite py-80">
    <div class="container">
        <div class="coursePart mb-3">
            <h2 class="colorWhite text-center mt-2 mb-4">Method 1 : Give Using Your Phone</h2>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
                    <div class="methodBG"><img src="./../../../assets/images/phone.png" class="img-fluid" /></div>
                </div>
                <div class="col-12 col-md-6 col-lg-9 mb-3 mb-lg-0">
                    <p class="colorWhite"  [innerHtml]="GiveUsingPhone">
                    </p>
                </div>
            </div>
        </div>

        <div class="coursePart mb-3">
            <h2 class="colorWhite text-center mt-2 mb-4">Method 2 : Give Through PushPay</h2>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-9 mb-3 mb-lg-0 order-2 order-lg-1">
                    
                    <div class="colorWhite" [innerHtml]="GiveUsingPushPay">

                    </div>
                    <a href=" http://www.pushpay.com/p/crosswindchurchdenver"  type="button" class="btn btnPrimary">Go To PushPay</a>
                </div>
                <div class="col-12 col-md-6 col-lg-3 mb-3 mb-lg-0 order-1 order-lg-2">
                    <div class="methodBG"><img src="./../../../assets/images/give-pushpay.jpg" height="1000px" class="img-fluid" /></div>
                </div>
            </div>
        </div>
        
        <!-- <div class="coursePart mb-3">
            <h2 class="colorWhite text-center mt-2 mb-4">King Soopers shopping supports our church</h2>
            <div class="row">
                <div class="colorWhite">
                    <p>
                        When you shop at King Soopers with your usual account, they will donate up to 5% of your transaction total
                        to our church.
                        It will not cost you a penny, and you get the same rewards and fuel perks that you are used to. All you have
                        to do is enroll, and enrolling is EASY!
                        <a [routerLink]="['/kingsoopers']">Click </a> this link to enroll.
                    </p>
                </div>
            </div>
        </div> -->

        <div class="bgWhite py-80">
            <div class="container">
                <h1 class="text-center mb-5"  style="color: #f78e41;">King Soopers shopping supports our church</h1>
                
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-12 mb-3 mb-lg-0">
                        <p>
                            When you shop at King Soopers with your usual account, they will donate up to 5% of your transaction total
                            to our church.
                            It will not cost you a penny, and you get the same rewards and fuel perks that you are used to. All you have
                            to do is enroll, and enrolling is EASY!
                            <a [routerLink]="['/kingsoopers']">Click </a> this link to enroll.
                        </p>
                    </div>
                </div>
            
            </div>
        </div>
    </div>
</div>